export const drawerStyles = {
  components: {
    Drawer: {
      variants: {
        "with-shadow": {
          placement: "right",
          boxShadow: "0 0 2px 2px #efdfde",
          bgColor: "red",
        },
      },
    },
  },
};
